import { Button, Input, Table } from "antd";
import { userLookupColumns } from "./user_lookup_columns";
import { lookupUserByEmail } from "./user-lookup.api";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { SORT_DIRECTIONS } from "common/constants";
import { Content } from "antd/lib/layout/layout";
import { SearchOutlined } from "@ant-design/icons";

export const UserLookup = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState(searchParams.get("email") || "");

    const handleSearch = async () => {
        if (!email || !email.trim()) {
            return;
        }

        const trimmedEmail = email.trim();
        setSearchParams({ email: trimmedEmail });
        setLoading(true);
        try {
            const result = await lookupUserByEmail(trimmedEmail);
            setUsers(result || []);
        } catch (error) {
            console.error("Error fetching user access:", error);
            setUsers([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const emailParam = searchParams.get("email");
        if (emailParam && emailParam.trim()) {
            const trimmedEmail = emailParam.trim();
            setEmail(trimmedEmail);
            setLoading(true);
            lookupUserByEmail(trimmedEmail)
                .then((result) => {
                    setUsers(result || []);
                })
                .catch((error) => {
                    console.error("Error fetching user access:", error);
                    setUsers([]);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, []);

    const handleEmailChange = (e) => {
        setEmail(e?.target?.value || "");
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSearch();
        }
    };

    return (
        <Content style={{ padding: 24 }}>
            <div style={{ marginBottom: 24, display: "flex", gap: 8 }}>
                <Input
                    autoFocus={true}
                    allowClear
                    placeholder="Enter email address"
                    value={email}
                    onChange={handleEmailChange}
                    onKeyPress={handleKeyPress}
                    style={{ width: 300 }}
                />
                <Button
                    type="primary"
                    icon={<SearchOutlined />}
                    onClick={handleSearch}
                    loading={loading}>
                    Search
                </Button>
            </div>
            <Table
                bordered
                columns={[...userLookupColumns]}
                dataSource={users}
                loading={loading}
                pagination={{
                    position: ["bottomCenter"],
                    hideOnSinglePage: true,
                    pageSizeOptions: [20, 50, 100],
                    defaultPageSize: 20,
                    showTotal: (total) => `Total ${total} items`,
                }}
                rowKey={(record, index) => `${record.brandUserId}-${index}`}
                scroll={{
                    scrollToFirstRowOnChange: true,
                    y: "calc(100vh - 180px)",
                    x: 1000,
                }}
                size="small"
                sortDirections={SORT_DIRECTIONS}
                style={{ width: "100%", height: "100%" }}
            />
        </Content>
    );
};
